import { BASE_URL, REFRESH_TOKEN_URL } from './APIConstants';
import { RefreshToken, removeLoginFlag, setAuthToken } from './Token';

const is_dev = process.env.NODE_ENV === 'development';

// Track the registered interceptor ID so we only ever register once on the
// shared axios singleton. Without this guard, every requestData / sendData
// call (including the polling loop in pollTaskStatus) would stack a new
// interceptor, causing duplicate refresh attempts and memory growth.
let _interceptorId = null;

const Interceptor = (axios_) => {
  if (_interceptorId !== null) {
    return;
  }
  _interceptorId = axios_.interceptors.response.use(
    (response) => {
      return response;
    },
    async function (error) {
      const originalConfig = error.config;
      if (
        error.response.status === 401 &&
        originalConfig.url.indexOf(REFRESH_TOKEN_URL) === -1
      ) {
        const res = await axios_.post(
          `${BASE_URL}${REFRESH_TOKEN_URL}`,
          is_dev
            ? {
                refresh: RefreshToken(),
              }
            : {}
        );
        if (res.status === 200 || res.status === 201) {
          if (is_dev) {
            setAuthToken(res.data.access);
          }
          return axios_({
            method: originalConfig.method,
            url: originalConfig.url,
            headers: { Authorization: `Bearer ${res.data.access}` },
            withCredentials: !is_dev,
            data: originalConfig.data,
          });
        } else {
          removeLoginFlag();
        }
      }
      return Promise.reject(error);
    }
  );
};

export default Interceptor;
